'use client';

import React, { useState } from 'react';
import styles from './FileUploader.module.scss';
import { FileUploaderProps } from './types';

export const FileUploader = ({ label, maxSizeLabel }: FileUploaderProps) => {
	const [files, setFiles] = useState<File[]>([]);
	const [fileSizeError, setFileSizeError] = useState(false);

	const onChangeFun = (e: any) => {
		const newFile = e.target.files[0];
		if (newFile) {
			if (newFile.size > 2000000) {
				setFileSizeError(true);
			} else {
				const updatedFiles: any = [...files, newFile];
				setFiles(updatedFiles);
			}
		}
	};

	return (
		<div className={styles.fileUploaderWrapper}>
			<div className={styles.fileUploaderLabel}>
				<label htmlFor="fileUploader">{label}</label>

				<div className={styles.fileUploaderInput}>
					<input type="file" id="fileUploader" multiple={true} onChange={onChangeFun} />
				</div>
			</div>
			<p className={fileSizeError ? styles.fileUploaderWarningError : styles.fileUploaderWarning}>
				{maxSizeLabel}
			</p>
			<div className={styles.fileUploaderFiles}>
				{Object.values(files).map((file: File, index: number) => {
					return <p key={index}>{file.name}</p>;
				})}
			</div>
		</div>
	);
};
